import './App.css';
import { Route, Routes} from 'react-router-dom';

//Components
import Navbar from './components/navbar';

//Pages
import NotFound from './pages/NotFound';
import Home from './pages/Home';
import CodingProjects from './pages/CodingProjects';
import VideogameProjects from './pages/VideogameProjects';
import AnimationProjects from './pages/AnimationProjects';
import AssetProjects from './pages/AssetProject';


function App() {
	return (
		<>
			<Navbar/>
			<Routes>
				<Route path = "/" element = {<Home/>}/>
				<Route path = "/CodingProjects" element = {<CodingProjects/>}/>
				<Route path = "/VideogameProjects" element = {<VideogameProjects/>}/>
				<Route path = "/AnimationProjects" element = {<AnimationProjects/>}/>
				<Route path = "/3DAssetProjects" element = {<AssetProjects/>}/>
				<Route path = "*" element = {<NotFound/>}/>
			</Routes>
		</>
	);
}

export default App;
